module.exports = __webpack_public_path__ + "img/item-4-2.3e84cff7.png";